import { render } from "./Sales1.vue?vue&type=template&id=15a4387b&scoped=true"
import script from "./Sales1.vue?vue&type=script&lang=js"
export * from "./Sales1.vue?vue&type=script&lang=js"

import "./Sales1.vue?vue&type=style&index=0&id=15a4387b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-15a4387b"

export default script